export function Logo({ className }: { className: string }) {
  return (
    <svg
      viewBox="0 0 479 932"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M478.996 333.171V81.869C478.996 48.5682 440.683 29.8489 414.413 50.3147L91.8458 301.617C61.814 325.014 78.3588 373.171 116.429 373.171H438.996C461.087 373.171
478.996 355.263 478.996 333.171Z"
      />
      <path
        d="M478.996 734.898V482.793C478.996 460.701 461.087 442.793 438.996 442.793H116.201C78.1552 442.793 61.5954 490.899 91.5799 514.317L414.375 766.423C440.638 786.934
478.996 768.221 478.996 734.898Z"
      />
      <path
        d="M0 891.777V610.558C0 577.169 38.4905 558.476 64.732 579.12L261.334 733.787C270.99 741.383 276.619 752.995 276.602 765.28L276.425 892.018C276.395 914.103 258.472
931.983 236.388 931.962L39.9622 931.777C17.8856 931.756 0 913.854 0 891.777Z"
      />
    </svg>
  );
}
